import React, { memo } from 'react';
export function PainPoints() {
  const pains = [{
    icon: '😓',
    title: 'Respondés el precio por chat',
    desc: 'Sin presupuesto, sin formato, sin profesionalismo. La clienta ve el número sin contexto y dice "es caro".'
  }, {
    icon: '📋',
    title: 'Sin ficha de clienta',
    desc: 'Confiás en tu memoria. Y cuando vuelve después de tres meses, no recordás qué tratamiento le hiciste.'
  }, {
    icon: '📉',
    title: 'No sabés cuánto ganás realmente',
    desc: 'Cobrás por turno pero a fin de mes los números no cierran y no sabés por qué.'
  }, {
    icon: '😰',
    title: 'Miedo de subir los precios',
    desc: 'Sabés que deberías cobrar más pero no tenés el método ni el mensaje para comunicarlo sin perder clientas.'
  }, {
    icon: '📱',
    title: 'Redes sin plan',
    desc: 'Publicás cuando te acordás, sin constancia, sin saber qué poner y sintiéndote culpable cuando pasan semanas sin postear.'
  }, {
    icon: '❌',
    title: 'Cancelaciones sin consecuencias',
    desc: 'Nunca estableciste condiciones claras por escrito. Cada cancelación es un turno perdido sin poder hacer nada.'
  }, {
    icon: '🔄',
    title: 'Presupuestos en el visto',
    desc: 'Mandás el precio por chat, no te responden y no sabés si escribir de nuevo sin parecer desesperada.'
  }, {
    icon: '📅',
    title: 'Fin de mes sin crecimiento',
    desc: 'Trabajás igual que siempre, ganás igual que siempre y no sabés exactamente cómo salir de ese techo.'
  }];
  return <section className="bg-oscuro text-white py-10 sm:py-16 px-5" data-id="element-262">
      <div className="max-w-[860px] mx-auto" data-id="element-263">
        <div className="text-center mb-8 sm:mb-12" data-id="element-264">
          <h2 className="text-[clamp(22px,4vw,34px)] font-extrabold leading-[1.2] mb-3 text-white uppercase" data-id="element-265">
            ¿TE PASA ESTO?
          </h2>
          <p className="text-[#AAAAAA] max-w-[560px] mx-auto text-[15px]" data-id="element-266">
            Si trabajás en estética en Argentina, esto te suena familiar:
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 sm:gap-4" data-id="element-267">
          {pains.map((pain, idx) => <div key={idx} className="bg-white/5 border border-white/10 rounded-xl p-5" data-id="element-268">
              <div className="text-[22px] mb-2" data-id="element-269">{pain.icon}</div>
              <strong className="block text-[14px] font-bold text-white mb-1" data-id="element-270">
                {pain.title}
              </strong>
              <p className="text-[13px] text-[#BBBBBB] leading-relaxed" data-id="element-271">
                {pain.desc}
              </p>
            </div>)}
        </div>

        <p className="text-center text-[#AAAAAA] mt-6 sm:mt-9 text-[16px] font-semibold" data-id="element-272">
          ¿Cuántos meses más vas a trabajar sin el sistema que te falta?
        </p>
      </div>
    </section>;
}